import { render, staticRenderFns } from "./AppCampaignInbox.vue?vue&type=template&id=c499da18&"
import script from "./AppCampaignInbox.vue?vue&type=script&lang=js&"
export * from "./AppCampaignInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports